import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../../config";
import ProductCard from "../productCard";

const ProductRecommendation = ({ productDetail }) => {
  const [productToRecomand, setProductToRecommand] = useState([]);

  const fetchProductToRecommand = async (categoryId) => {
    try {
      const { data } = await axios.get(
        `${config.apiUrl}/one/categories/${categoryId}`
      );

      const productCategory = data.data.products;
      const productCategoryFiltered = productCategory.filter((product) => {
        return (
          // parseFloat(product.price) <= parseFloat(productDetail.price) + 10 &&
          // parseFloat(product.price) >= parseFloat(productDetail.price) - 200 &&
          productDetail.id !== product.id 
        );
      });

      console.log("Category products:", productCategoryFiltered);

      setProductToRecommand(productCategoryFiltered);

      
    } catch (error) {
      console.error("Failed to fetch category products:", error);
    }
  };

  useEffect(() => {
    fetchProductToRecommand(productDetail.category.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("product to recommend", productToRecomand);
  }, [productToRecomand])

  return (
    <div className=" container">
      <h2 className="mb-3 text-center# h4 ">
        Similar products
      </h2>
      <div className=" row ">
        {productToRecomand.length > 0 && productToRecomand.slice(0, 4).map((product, index) => {
          return (
            <ProductCard product={product} key={product.id + " - " + index} pathName={`/market-place/product-details/${product.id}`}/>
          );
        })}
      </div>
    </div>
  );
};

export default ProductRecommendation;
